import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Modal from '../../../Modal';
import './style.css';

class DialogModal extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      isMaskClosable = false,
      isOverFlowVisible = true,
      onClose,
      children,
      size,
    } = this.props;
    return (
      <Modal isMaskClosable={isMaskClosable} onClose={onClose}>
        <div
          className={cx('v3-dialog', {
            'v3-dialog-large': !!size,
            'overflow-visible': isOverFlowVisible,
          })}
        >
          {children}
        </div>
      </Modal>
    );
  }
}

DialogModal.propTypes = {
  isMaskClosable: PropTypes.bool,
  children: PropTypes.node,
  size: PropTypes.string,
  onClose: PropTypes.func,
  isOverFlowVisible: PropTypes.bool,
};

export default DialogModal;



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/componentsv3/Dialog/components/DialogModal/index.js
 **/